export default function GhostInfoSection({ title, children }: { title: string, children: string | JSX.Element | null | undefined | (string | JSX.Element | null | undefined)[] }) {
    return (
        <div className="mt-2">
            <h5 className="fw-bold">{title}</h5>
            {children}
        </div>
    );
}